import { I18n } from "i18n-js";

const i18n = new I18n();

i18n.locale = window.LOCALE || "en";
i18n.defaultLocale = window.DEFAULT_LOCALE || "en";
i18n.enableFallback = true;
i18n.missingBehavior = "guess";
i18n.missingTranslationPrefix = "EE: ";

(window.I18nlocales || []).forEach((locale) => {
  i18n.store(locale);
});

if (window) window.I18n = i18n;
if (global) global.I18n = i18n;
